import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { SuggestedFaqDetailsState, SLICE_NAME } from './models';

const suggestedFaqDetailsSelector = (state: RootState): SuggestedFaqDetailsState => state[SLICE_NAME];

export const selectSuggestedFaqDetails = createSelector(
  suggestedFaqDetailsSelector,
  (state: SuggestedFaqDetailsState) => state.item,
);

export const selectSuggestedFaqDetailsIsLoading = createSelector(
  suggestedFaqDetailsSelector,
  (state: SuggestedFaqDetailsState) => state.isLoading,
);

export const selectSuggestedFaqDetailsError = createSelector(
  suggestedFaqDetailsSelector,
  (state: SuggestedFaqDetailsState) => state.error,
);
